<template>
    <div :class="notPositon ? 'yellowTitle_' : 'yellowTitle'" :id="failed ? 'failed' : ''">
        {{info}}
    </div>
</template>

<script>
    export default {
        name: "yellowTitle",
        props:['info', 'notPositon', 'failed'],
        data() {return{}},
        created() {

        }
    }
</script>

<style scoped>
    #failed {
        background-image: url("http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20230605145344260.png");
    }
    .yellowTitle{
        width: 210px;
        height: 35px;
        background-image: url("http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20230605145329870.png");
        background-repeat: no-repeat;
        color: #fff;
        background-size: 100%;
        font-size: 18px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0.8;
        position: absolute;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        top: 0;
        letter-spacing: 3px;
        box-sizing: border-box;
        padding-left: 7px;
    }
    .yellowTitle_{
        width: 210px;
        height: 35px;
        background-image: url("http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20230605145329870.png");
        background-repeat: no-repeat;
        color: #fff;
        background-size: 100%;
        font-size: 18px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0.8;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        letter-spacing: 3px;
        box-sizing: border-box;
        padding-left: 7px;
    }
</style>